import { NgModule } from '@angular/core';
import { SharedModule } from 'app/components/shared.module';
import { SectionModule } from 'app/views/presentations/layouts/layouts/section.module';
import { TwoSectionsHorizontalLayout, TwoSectionsHorizontalLayoutComponent } from 'app/views/presentations/layouts/layouts/twoSectionsHorizontalLayout/twoSectionsHorizontalLayout.component';
import { LayoutWrapperModule } from 'app/views/presentations/layouts/layoutWrapper.module';

@NgModule({
    imports: [
        SharedModule,
        SectionModule,
        LayoutWrapperModule.wrapLayout(TwoSectionsHorizontalLayout)
    ],
    declarations: [
        TwoSectionsHorizontalLayoutComponent
    ],
    entryComponents: [
        TwoSectionsHorizontalLayoutComponent
    ]
})
export class TwoSectionsHorizontalLayoutModule { }


// WEBPACK FOOTER //
// ./src/app/views/presentations/layouts/layouts/twoSectionsHorizontalLayout/twoSectionsHorizontalLayout.module.ts